import TinyOSS from 'tiny-oss'
import { fetchData } from './fetch'

/**
 * 图片等比缩小
 * @param {File} file 图片文件
 * @param {Number} maxWidth 最大宽度（单位：px）
 * @returns {Promise<File>} 返回调整后的文件
 */
export const resizeImage = (file, maxWidth) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const image = new Image()
      image.onload = () => {
        // 获取原始宽高
        const { width, height } = image

        // 如果宽度超过最大宽度，进行缩放
        if (width > maxWidth) {
          const scale = maxWidth / width // 计算缩放比例
          const newWidth = maxWidth
          const newHeight = height * scale // 等比缩放高度

          const canvas = document.createElement('canvas')
          canvas.width = newWidth
          canvas.height = newHeight
          const ctx = canvas.getContext('2d')
          ctx.drawImage(image, 0, 0, newWidth, newHeight)

          canvas.toBlob((blob) => {
            const miniFile = new File([blob], file.name, {
              type: 'image/jpeg'
            })
            resolve(miniFile)
          }, 'image/jpeg')
        } else {
          resolve(file) // 如果宽度不超过最大值，直接返回原文件
        }
      }
      image.src = e.target.result
    }
    reader.readAsDataURL(file)
  })
}

/**
 * 图片压缩
 * @param {string} file 文件
 * @param {Number} quality 压缩质量 0 ~ 1之间
 */
export const compressImg = (file, quality) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const image = new Image()
      image.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        canvas
          .getContext('2d')
          .drawImage(image, 0, 0, image.width, image.height)
        const canvasURL = canvas.toDataURL('image/jpeg', quality) // 转成base64
        const buffer = atob(canvasURL.split(',')[1]) // 解码base64
        let length = buffer.length
        const bufferArray = new Uint8Array(length)
        while (length--) {
          bufferArray[length] = buffer.charCodeAt(length)
        }
        const miniFile = new File([bufferArray], file.name, {
          type: 'image/jpeg'
        })
        resolve({
          file: miniFile,
          origin: file,
          beforeSrc: e.target.result,
          afterSrc: canvasURL,
          beforeKB: Number((file.size / 1024).toFixed(2)),
          afterKB: Number((miniFile.size / 1024).toFixed(2))
        })
      }
      image.src = e.target.result
    }
    reader.readAsDataURL(file)
  })
}

/**
 * 上传图片
 * @param {File} file 文件
 * @param {Number} size 文件大小(kb),超出开启压缩
 * @param {Number} quality 压缩质量 0 ~ 1之间
 */
export const uploadImage = async (file, size = 200, quality = 0.2) => {
  const { data } = await fetchData('/dsp-app/alibaba-common/ossCredentials')
  let BASE_URL = 'https://1688-upload-image.bestdealer.com'
  const ossOptions = {
    bucket: '1688images',
    region: 'oss-us-east-1',
    accessKeyId: data.accessKeyId,
    accessKeySecret: data.accessKeySecret,
    stsToken: data.securityToken,
    secure: true
  }

  if (import.meta.env.VITE_APP_ENV === 'development') {
    ossOptions.bucket = '1688images-test'
    ossOptions.region = 'oss-cn-shenzhen'
    BASE_URL = 'https://1688-upload-image.lerdex.co'
  }

  const client = new TinyOSS(ossOptions)

  // 超出200kb开启压缩
  const isCompress = file.size > size * 1024

  if (file.type.includes('webp')) {
    file = await resizeImage(file, 800)
    const { file: miniFile } = await compressImg(
      file,
      isCompress ? quality : 0.8
    )
    file = miniFile
  } else {
    if (isCompress) {
      file = await resizeImage(file, 800)
      const { file: miniFile } = await compressImg(file, quality)
      file = miniFile
    }
  }

  return new Promise((resolve, reject) => {
    client
      .put(file.name, file, {
        headers: {
          'Content-Type': file.type // 动态设置文件类型
        }
      })
      .then((res) => {
        resolve({
          fileUrl: `${BASE_URL}/${file.name}`
        })
      })
      .catch((err) => {
        console.log(err)
      })
  })
}
